"use client";

import { c as _c } from "react/compiler-runtime";
import SearchXIcon from "@/assets/icons/search-x.svg";
import { cn } from "@/lib/utils";
export type EmptyStateProps = {
  /** Main message shown to the user */
  title?: string;
  /** Optional secondary description */
  description?: string;
  /** Optional custom icon (defaults to SearchX) */
  icon?: React.ReactNode;
  /** Optional action button or element */
  action?: React.ReactNode;
  /** Additional class names for the container */
  className?: string;
};
export function EmptyState(t0) {
  const $ = _c(18);
  const {
    title: t1,
    description: t2,
    icon,
    action,
    className
  } = t0;
  const title = t1 === undefined ? "No Results Found" : t1;
  const description = t2 === undefined ? "Try adjusting your search or filters to find what you're looking for." : t2;
  let t3;
  if ($[0] !== className) {
    t3 = cn("flex flex-col items-center justify-center py-16 px-6 text-center", className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== icon) {
    t4 = icon ?? <SearchXIcon className="size-12 text-muted-foreground" aria-hidden={true} />;
    $[2] = icon;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = <div className="rounded-full bg-muted p-4 mb-4">{t4}</div>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== title) {
    t6 = <h3 className="text-lg font-semibold text-gray-700 mb-2">{title}</h3>;
    $[6] = title;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== description) {
    t7 = description ? <p className="text-muted-foreground max-w-sm mb-6">{description}</p> : null;
    $[8] = description;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== action) {
    t8 = action && <div className="flex justify-center">{action}</div>;
    $[10] = action;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t3 || $[13] !== t5 || $[14] !== t6 || $[15] !== t7 || $[16] !== t8) {
    t9 = <div className={t3}>{t5}{t6}{t7}{t8}</div>;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}